import React from 'react';
import { Link } from 'react-router-dom';
import RecentInsights from '../components/home/RecentInsights';
import { home, portraitAlt } from '../content/siteCopy';
import './HomePage.css';

function HomePage() {
  return (
    <div className="home-page">
      <section className="home-hero" aria-labelledby="home-title">
        <div className="home-hero__inner">
          <div className="home-hero__content">
            <h1 className="home-hero__title" id="home-title">
              {home.hero.title}
            </h1>
            <p className="home-hero__lead">{home.hero.lead}</p>
            <div className="home-hero__actions">
              <Link
                className="home-page__button home-page__button--primary"
                to={home.hero.primaryAction.to}
              >
                {home.hero.primaryAction.label}
                <span aria-hidden="true">→</span>
              </Link>
              <Link
                className="home-page__button home-page__button--secondary"
                to={home.hero.secondaryAction.to}
              >
                {home.hero.secondaryAction.label}
              </Link>
            </div>
          </div>

          <div className="home-hero__media">
            <div className="home-hero__image-frame">
              <img
                alt={portraitAlt}
                className="home-hero__image"
                decoding="async"
                fetchPriority="high"
                height="2100"
                src="/images/vagelis-antoniadis-portrait.jpg"
                width="1574"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="home-intro" aria-labelledby="home-intro-title">
        <div className="home-page__section-inner home-intro__layout">
          <div>
            <p className="home-page__eyebrow">{home.intro.eyebrow}</p>
            <h2 className="home-intro__title" id="home-intro-title">
              {home.intro.title}
            </h2>
          </div>
          <div className="home-intro__copy">
            {home.intro.paragraphs.map(paragraph => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <Link className="home-page__text-link" to={home.intro.link.to}>
              {home.intro.link.label}
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </section>

      <section className="home-expertise" aria-labelledby="home-expertise-title">
        <div className="home-page__section-inner">
          <div className="home-expertise__header">
            <p className="home-page__eyebrow home-page__eyebrow--inverse">
              {home.expertise.eyebrow}
            </p>
            <h2 className="home-expertise__title" id="home-expertise-title">
              {home.expertise.title}
            </h2>
          </div>

          <ol className="home-expertise__list">
            {home.expertise.areas.map(area => (
              <li className="home-expertise__item" key={area.number}>
                <span className="home-expertise__number" aria-hidden="true">
                  {area.number}
                </span>
                <h3>{area.title}</h3>
                <p>{area.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <RecentInsights />

      <section className="home-contact" aria-labelledby="home-contact-title">
        <div className="home-page__section-inner home-contact__layout">
          <div>
            <p className="home-page__eyebrow">{home.contact.eyebrow}</p>
            <h2 className="home-contact__title" id="home-contact-title">
              {home.contact.title}
            </h2>
          </div>
          <div className="home-contact__action">
            <p>{home.contact.body}</p>
            <Link
              className="home-page__button home-page__button--primary"
              to={home.contact.action.to}
            >
              {home.contact.action.label}
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
